import { Box, CircularProgress, Typography, Tooltip } from "@material-ui/core";
import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function BigNumberCard({
  value,
  title,
  loading,
  onClick,
  icon,
  legend,
}) {
  const cardContent = (
    <Box
      width="100%"
      style={{
        backgroundColor: themeColorsDesingSystem.secondary.active,
        cursor: onClick ? "pointer" : "default",
      }}
      borderRadius="14px"
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      padding="1rem"
      onClick={onClick}
    >
      {icon}
      <Typography variant="subtitle2" align="center">
        {title}
      </Typography>
      <Typography variant="h3" align="center">
        {value}
      </Typography>
    </Box>
  );

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress color="inherit" size="1rem" />
        </div>
      ) : (
        <div>
          {legend ? (
            <Tooltip title={legend} arrow>
              {cardContent}
            </Tooltip>
          ) : (
            cardContent
          )}
        </div>
      )}
    </>
  );
}
